const hero = require('./hero');
const categories = require('./categories');
const sweepstakes = require('./sweepstakes');
const wordaful = require('./wordaful');
const more = require('./getMore');
const download = require('./downloadWrapper');
const social = require('./socialFeed');

const data = {
  "heroSection": hero,
  "categorySection": categories,
  "sweepstakesSection": sweepstakes,
  "wordafulSection": wordaful,
  "getMore": more,
  "downloadWrapper": download,
  "socialFeed": social
}

module.exports = data;
